// Keep the saved color authoritative. Neutral ink adapts only when it would
// disappear against the canvas; switching back restores the chosen color.
export function drawingColor(color, theme = 'light') {
  if (!/^#[0-9a-f]{6}$/i.test(color || '')) return color
  const rgb = [1, 3, 5].map(index => parseInt(color.slice(index, index + 2), 16))
  if (Math.max(...rgb) - Math.min(...rgb) > 24) return color
  const lightness = rgb.reduce((sum, value) => sum + value, 0) / 3
  const needsContrast = theme === 'dark' ? lightness < 120 : lightness > 190
  if (!needsContrast) return color
  const value = Math.round(theme === 'dark' ? 220 - lightness * 0.25 : 35 + (255 - lightness) * 0.25)
  const hex = value.toString(16).padStart(2, '0')
  return `#${hex}${hex}${hex}`
}
